import { localeSchema, type Locale } from './localeSchema'
import fiJson from './fi.json'

export const fiLocale: Locale = localeSchema.parse(fiJson)

export function getCurrentLocale(): Locale {
  return fiLocale
}
